import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type DownloadFileIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const DownloadFileIcon: React.FC<DownloadFileIconProps> = ({ width = 16, height = 16, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path d="M4.66667 4.42013L11.3333 4.42013M4.66667 6.62303H11.3333M6.57143 8.82592V12.681M6.57143 12.681L8.2381 10.7535M6.57143 12.681L4.90476 10.7535M10.1429 14.3332H3.2381C3.1066 14.3332 3 14.2099 3 14.0578V1.94187C3 1.78979 3.1066 1.6665 3.2381 1.6665H12.7619C12.8934 1.6665 13 1.78979 13 1.94187V11.0288M10.1429 14.3332L13 11.0288M10.1429 14.3332V11.3042C10.1429 11.1521 10.2495 11.0288 10.381 11.0288H13" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </IconSpan>
);
